export default __webpack_public_path__ + "static/media/logo.21b3ba87.svg";